import React from 'react';
import { Card, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccMaterial } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const MaterialDependencyPanel: React.FC<Props> = ({ params }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccMaterial(params);
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card id="material" title="Material dependency" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r, i) => `${r.work_order_number}-${i}`}
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => r.deepLink && navigate(String(r.deepLink)),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Operation', dataIndex: 'operation' },
          { title: 'Open MRs', dataIndex: 'open_mr_count', width: 90 },
          { title: 'MR status', dataIndex: 'mr_statuses', render: (v: string[]) => (v || []).join(', ') },
          { title: 'Blocked h', dataIndex: 'blocked_hours', width: 90 },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default MaterialDependencyPanel;
